import React, {
  useState,
  useContext,
  useEffect,
  useCallback,
} from "react"
import "./filter.scss"
import { StaticImage } from "gatsby-plugin-image"
import {
  categories,
  categoriesFilterProp,
  prices,
  pricesFilterProps,
} from "./filterdata"
import CustomDropDownMenu from "../common/customDropdown/CustomDropDownMenu"
import { useMediaQuery } from "react-responsive"
import {
  GlobalDispatchContext,
  GlobalStateContext,
} from "../../context/GlobalContextProvider"

const Filter = (props) => {
  const { closeFilter, handleClearFilters } = props
  const state = useContext(GlobalStateContext) || {}
  const dispatch = useContext(GlobalDispatchContext)
  const [filterCount, setFilterCount] = useState(0)

  const filtersObject = state.filtersObject || {}
  const categoryFilters = filtersObject.categories || {}
  const priceFilters = filtersObject.prices || {}

  const setFilterCountValue = useCallback(() => {
    let count = 0

    Object.values(categoryFilters).forEach((v) => {
      if (v === true) count++
    })
    Object.values(priceFilters).forEach((v) => {
      if (v === true) count++
    })

    setFilterCount(count)
  }, [categoryFilters, priceFilters])

  useEffect(() => {
    if (filtersObject) {
      setFilterCountValue()
    }
    return () => setFilterCount(0)
  }, [filtersObject, setFilterCountValue])

  const isMobile = useMediaQuery({
    query: "(max-width: 767px)",
  })

  const [accordionStatuses, setAccordionStatuses] = useState({
    categories: true,
    prices: true,
    ratings: true,
    difficulties: true,
    skills: true,
  })

  const handleAccordionClick = (accName) => {
    setAccordionStatuses((prev) => ({
      ...prev,
      [accName]: !prev[accName],
    }))
  }

  const handleChange = (type, id, value) => {
    const currentFilters = state.filtersObject || {}
    const typeValue = currentFilters[type] || {}

    const values = {
      ...typeValue,
      [id]: value,
    }

    const newFilterObject = {
      ...currentFilters,
      [type]: values,
    }

    dispatch({
      type: "SET_FILTER_VALUES",
      payload: newFilterObject,
    })

    // always work on a copy
    let filterOptions = [
      ...(state.selectedFilterOptions || []),
    ]

    if (value === true) {
      if (type === "categories") {
        const key = categoriesFilterProp[id - 1]
        if (!filterOptions.includes(key)) {
          filterOptions.push(key)
        }
      } else if (type === "prices") {
        const key = pricesFilterProps[id - 1]
        if (!filterOptions.includes(key)) {
          filterOptions.push(key)
        }
      }
    } else {
      if (type === "categories") {
        const key = categoriesFilterProp[id - 1]
        filterOptions = filterOptions.filter((fil) => fil !== key)
      } else if (type === "prices") {
        const key = pricesFilterProps[id - 1]
        filterOptions = filterOptions.filter((fil) => fil !== key)
      }
    }

    dispatch({
      type: "SET_FILTER_OPTIONS",
      payload: filterOptions,
    })
  }

  return (
    <div className="filterSection">
      <div className="filterLeft">
        <div className="filterHeader">
          <div className="filterTitle">
            <h2 className="filterTitleText">Filter</h2>
            {isMobile ? (
              <div className="filterClear">
                <span className="clear" onClick={closeFilter}>
                  <StaticImage
                    src="../../assets/images/cross.png"
                    alt=""
                  />
                </span>
              </div>
            ) : (
              <div
                className="filterClear"
                onClick={handleClearFilters}
              >
                <span className="clear">
                  <StaticImage
                    src="../../assets/images/cross.png"
                    alt=""
                  />
                </span>
                Clear filters({filterCount})
              </div>
            )}
          </div>
        </div>

        <CustomDropDownMenu
          title="Category"
          isOpen={accordionStatuses.categories}
          filterName="categories"
          onAccordionClick={handleAccordionClick}
          filterList={categories}
          handleChange={handleChange}
        />

        <CustomDropDownMenu
          title="Price"
          isOpen={accordionStatuses.prices}
          filterName="prices"
          onAccordionClick={handleAccordionClick}
          filterList={prices}
          handleChange={handleChange}
        />
      </div>

      <div className="proudctSec" />

      {isMobile && (
        <div className="actionBtnContainer">
          <button onClick={closeFilter} className="btnApply">
            Apply
          </button>
          <button
            className="btnReset"
            onClick={handleClearFilters}
          >
            Reset
          </button>
        </div>
      )}
    </div>
  )
}

export default Filter
